import { Combobox } from '@ui/components/v2/combobox';
import { wrapClassNames } from '@ui/utils/tailwind';
import { useTranslations } from 'next-intl';
import type { FC, ReactElement, ReactNode } from 'react';

export const SearchSelect: FC<{
  value?: string;
  label?: string | ReactElement;
  placeholder?: string;
  onChange: (v: string) => void;
  options: Array<{ value: string; label: string | ReactNode; isDisabled?: boolean }>;
  labelContainerClassName?: string;
  optionsClassName?: string;
  disabled?: boolean;
}> = ({ value, options, label, onChange, placeholder, labelContainerClassName = '', disabled, optionsClassName }) => {
  const v = value ? options.find(i => i.value === value) : undefined;
  const t = useTranslations('common');

  return (
    <div className="flex flex-col items-start w-full relative">
      {label && (
        <span
          className={wrapClassNames(
            `block mb-2 font-semibold text-gray-900 text-sm leading-ui ${labelContainerClassName}`
          )}
        >
          {label}
        </span>
      )}

      <Combobox
        disabled={disabled}
        optionsClassName={optionsClassName}
        searchPlaceholder={t('search')}
        placeholder={placeholder}
        value={v?.value}
        options={options}
        setValue={onChange}
        popoverContentClassName="w-96"
      />
    </div>
  );
};
